export default "__VITE_ASSET__CPOBkb_F__"